import { createBaseResourceActions } from '../create-base-resource-actions';
import { OrderCardAttributeResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ORDER CARD ATTRIBUTE]';
export const orderCardAttributeActions =
  createBaseResourceActions<OrderCardAttributeResourceTypeMappings>(domainSlug);
